<app-topbar (settingsButtonClicked)="onSettingsButtonClicked()"
    (menuButtonClicked)="menuOpen = true"></app-topbar>

<app-grid-menu *ngIf="menuOpen" (closed)="menuOpen = false"></app-grid-menu>

<router-outlet></router-outlet>
